import React from "react";

import type { Theme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Theme {
    spaces: {
      xxlarge: React.CSSProperties["padding"];
      xlarge: React.CSSProperties["padding"];
      large: React.CSSProperties["padding"];
      base: React.CSSProperties["padding"];
      medium: React.CSSProperties["padding"];
      small: React.CSSProperties["padding"];
      xsmall: React.CSSProperties["padding"];
      xxsmall: React.CSSProperties["padding"];
    };
  }

  interface ThemeOptions {
    spaces?: {
      xxlarge?: React.CSSProperties["padding"];
      xlarge?: React.CSSProperties["padding"];
      large?: React.CSSProperties["padding"];
      base?: React.CSSProperties["padding"];
      medium?: React.CSSProperties["padding"];
      small?: React.CSSProperties["padding"];
      xsmall?: React.CSSProperties["padding"];
      xxsmall?: React.CSSProperties["padding"];
    };
  }
}

const spaces: Theme["spaces"] = {
  xxlarge: "40px",
  xlarge: "32px",
  large: "24px",
  base: "16px",
  medium: "12px",
  small: "8px",
  xsmall: "4px",
  xxsmall: "2px",
};

export default spaces;
